import React, { useCallback, useEffect } from 'react';

import Skeleton from 'react-loading-skeleton';
import moment from 'moment';

import { FiCheck } from 'react-icons/fi';
import { AiOutlineRead, AiOutlineRetweet } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { StoreState } from '../../store/createStore';
import { order as onOrder, orderList } from '../../store/modules/order/actions';
import { orderListProps } from '../../store/modules/order/types';

import {
  Container,
  Header,
  Title,
  List,
  Item,
  ItemHeader,
  ItemNumber,
  ItemStatusOrder,
  ItemStatusDetail,
  ItemIcone,
  ItemDetails,
  ItemDetail,
  ItemShow,
  ItemAgain,
  ItemBtn,
} from './styles';
import { routesEndpoints } from '../../routes/endpoint';
import { orderByIDRemake } from '../../store/modules/checkout/actions';
import { setIsCategory } from '../../store/modules/parameter/actions';
import { RoundHelper } from '../../utils/roundHelper';

const Order: React.FC = () => {
  const { orders, loading } = useSelector((state: StoreState) => state.order);
  const {
    user: {
      data: { id },
    },
  } = useSelector((state: StoreState) => state.auth);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setIsCategory(false));
  }, [dispatch]);

  const history = useHistory();

  useEffect(() => {
    const requestOrder: orderListProps = {
      customer_id: id,
    };

    dispatch(orderList(requestOrder));
  }, [dispatch, id]);

  const handleadOrderShow = useCallback(
    (order: number) => {
      dispatch(onOrder(order));
      history.push(`${routesEndpoints.ORDERS_DETAIL}?id=${order}`);
    },
    [dispatch, history],
  );

  const handleadOrderRemake = useCallback(
    (order: number) => {
      dispatch(orderByIDRemake(order));
      history.push(routesEndpoints.NEW_CHECKOUT);
    },
    [dispatch, history],
  );
  return (
    <Container>
      <Header>
        <Title>
          <span>Histórico de Pedidos</span>
        </Title>
      </Header>
      <List>
        {loading ? (
          <>
            <Item key="99998">
              <ItemHeader>
                <ItemNumber>
                  <Skeleton
                    style={{ marginBottom: '16px', marginRight: '16px' }}
                    duration={1}
                    width={181}
                    height={35}
                  />
                </ItemNumber>
                <ItemStatusOrder>
                  <ItemStatusDetail>
                    <Skeleton
                      style={{ marginBottom: '16px', marginRight: '16px' }}
                      duration={1}
                      width={250}
                      height={52}
                    />
                  </ItemStatusDetail>
                  <ItemIcone>
                    <Skeleton
                      style={{ marginBottom: '16px', marginRight: '16px' }}
                      duration={1}
                      width={52}
                      height={52}
                    />
                  </ItemIcone>
                </ItemStatusOrder>
              </ItemHeader>
              <ItemDetails>
                <ItemDetail>
                  <Skeleton
                    style={{ marginBottom: '16px', marginRight: '16px' }}
                    duration={1}
                    width={400}
                    height={52}
                  />
                </ItemDetail>
                <ItemShow>
                  <Skeleton
                    style={{ marginBottom: '16px', marginRight: '16px' }}
                    duration={1}
                    width={310}
                    height={65}
                  />
                </ItemShow>
              </ItemDetails>
              <ItemAgain>
                <Skeleton
                  style={{ marginLeft: '20px' }}
                  duration={1}
                  width={290}
                  height={52}
                />
              </ItemAgain>
            </Item>
            <Item key="99999">
              <ItemHeader>
                <ItemNumber>
                  <Skeleton
                    style={{ marginBottom: '16px', marginRight: '16px' }}
                    duration={1}
                    width={181}
                    height={35}
                  />
                </ItemNumber>
                <ItemStatusOrder>
                  <ItemStatusDetail>
                    <Skeleton
                      style={{ marginBottom: '16px', marginRight: '16px' }}
                      duration={1}
                      width={250}
                      height={52}
                    />
                  </ItemStatusDetail>
                  <ItemIcone>
                    <Skeleton
                      style={{ marginBottom: '16px', marginRight: '16px' }}
                      duration={1}
                      width={52}
                      height={52}
                    />
                  </ItemIcone>
                </ItemStatusOrder>
              </ItemHeader>
              <ItemDetails>
                <ItemDetail>
                  <Skeleton
                    style={{ marginBottom: '16px', marginRight: '16px' }}
                    duration={1}
                    width={400}
                    height={52}
                  />
                </ItemDetail>
                <ItemShow>
                  <Skeleton
                    style={{ marginBottom: '16px', marginRight: '16px' }}
                    duration={1}
                    width={310}
                    height={65}
                  />
                </ItemShow>
              </ItemDetails>
              <ItemAgain>
                <Skeleton
                  style={{ marginLeft: '20px' }}
                  duration={1}
                  width={290}
                  height={52}
                />
              </ItemAgain>
            </Item>
          </>
        ) : (
          <>
            {orders &&
              !loading &&
              orders.orders?.map(order => (
                <Item key={order.order_id}>
                  <ItemHeader>
                    <ItemNumber>
                      <span>Pedido # {order.order_id}</span>
                    </ItemNumber>
                    <ItemStatusOrder>
                      <ItemStatusDetail>
                        <span>Status do Pedido </span>
                        <p>{order.status_label}</p>
                      </ItemStatusDetail>
                      <ItemIcone
                        type={order.status ? order.status : 'payment_approved'}
                      >
                        <FiCheck color="#fff" />
                      </ItemIcone>
                    </ItemStatusOrder>
                  </ItemHeader>
                  <ItemDetails>
                    <ItemDetail>
                      {order.shipping?.address && order.shipping?.number ? (
                        <>
                          <span>{` ${order.shipping?.address}, ${order.shipping?.number}`}</span>
                        </>
                      ) : (
                        <>
                          <span>Sem endereço</span>
                        </>
                      )}
                      <p>
                        Data:{' '}
                        {order.created_at &&
                          moment(order.created_at).format(
                            'DD/MM/YYYY HH:mm:ss',
                          )}{' '}
                        - Total {RoundHelper.toFormatted(order.grand_total)}
                      </p>
                    </ItemDetail>
                  </ItemDetails>
                  <ItemBtn>
                    <ItemAgain
                      onClick={() =>
                        order.order_id && handleadOrderRemake(order.order_id)}
                    >
                      <span>Pedir Novamente</span>
                      <AiOutlineRetweet size={25} color="#FFF" />
                    </ItemAgain>
                    <ItemShow
                      onClick={() =>
                        order.order_id && handleadOrderShow(order.order_id)
                      }
                    >
                      <span>revisar pedido</span>
                      <AiOutlineRead size={25} color="#FFF" />
                    </ItemShow>
                  </ItemBtn>
                </Item>
              ))}
          </>
        )}
      </List>
    </Container>
  );
};

export default Order;
